import { MoreHorizontalIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { type ApplyingTemplateDialogProps } from "./ApplyingTemplateDialog.types";

export default function ApplyingTemplateDialog({ open }: ApplyingTemplateDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="w-20 h-20 m-auto mb-5 rounded-full flex items-center justify-center bg-general-mint-600 border border-general-mint-800">
            <MoreHorizontalIcon className="w-16 h-16 stroke-general-green-800" />
          </div>
          <AlertDialogTitle className="text-center">{t("session.applyingTemplateDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription className="sr-only">
            {t("session.applyingTemplateDialog.title")}
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}
